<div class="row">
    <div class="col-md-12">
        <div class="card" >
            <div class="row" >
                <div class="col-md-9" >
                    <h5 class="headingValue">Chronological History</h5>
                </div>
              
                <div class="col-md-2 text-right">
                    <button type="button" class="globalBtn submitBtn" (click)="back()">Back</button>
            </div>
            </div>
            <hr>
            <div class="row" >
            <div class="col-md-12" >
                <label>Subject :</label>
                {{sheetDetails.noteSheetSubject}}
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive-sm">
                        <table class="table table-bordered table-hover">
                            <thead class="theadRow thead-light">
                                <tr>
                                    <th>Forwarded By</th>
                                    <th>To</th>
                                    <th>Comments</th>
                                    <th>Create Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let item of history">
                                <tr *ngIf="item.statusName !== 'SaveDispatch' && item.statusName !== 'NoteSheetSaved'">
                                    <td>
                                        {{item.senderActor !== null ? (item.senderActor):'-'}}
                                    </td>
                                    <td>
                                        {{item.receiverActor !== null ? (item.receiverActor):'-'}}
                                    </td>
                                    <td> {{item.comments !== null ? item.comments:'-'}}</td>
                                    <td style="white-space: nowrap;"> {{item.createdDate !== null ? item.createdDate:'-' | date:'dd-MM-yyyy hh:mm a'}}</td>
                                    <td>
                                        <span *ngIf="item.statusName ==='SaveDispatch' || item.statusName ==='NoteSheetSaved'" class="badge badge-pill badge-success"
                                            style="color: white;">Note Sheet Saved</span>
                                        <span *ngIf="item.statusName ==='SentForApproval'" class="badge badge-pill badge-success"
                                            style="color: white;">Sent For Approval</span>  
                                        <span *ngIf="item.statusName ==='SentToOtherSection'" class="badge badge-pill badge-success"
                                            style="color: white;">Sent To Other Section</span>
                                        <span *ngIf="item.statusName ==='ResponseReceivedfromOtherSection'"
                                            class="badge badge-pill badge-success" style="color: white;">Response
                                            Received from Other Section</span>
                                        <span *ngIf="item.statusName ==='Assigned'" class="badge badge-pill badge-success"
                                            style="color: white;">Assigned</span>
                                        <span *ngIf="item.statusName ==='Approved&Assigned'" class="badge badge-pill badge-success"
                                            style="color: white;"> Approved & Assigned</span>                                              
                                        <span *ngIf="item.statusName ==='underCorrection'" class="badge badge-pill badge-success"
                                            style="color: white;"> Under Correction</span>                                              
                                        <span *ngIf="item.statusName ==='ApprovedFinalized'" class="badge badge-pill badge-success"
                                            style="color: white;">Approved & Finalized</span>                                        
                                        <span *ngIf="item.statusName ==='PendingSignature'" class="badge badge-pill badge-success"
                                            style="color: white;">Pending Signature</span>                                            
                                        <span *ngIf="item.statusName ==='Signed'" class="badge badge-pill badge-success"
                                            style="color: white;">Signed</span>
                                        <span *ngIf="item.statusName ==='SendForDispatch'" class="badge badge-pill badge-success"
                                            style="color: white;">Sent For Dispatch</span>                                        
                                        <span *ngIf="item.statusName ==='Dispatched'" class="badge badge-pill badge-success"
                                            style="color: white;">Dispatched</span>
                                        <span *ngIf="item.statusName ==='Dispatched & Assigned'" class="badge badge-pill badge-success"
                                            style="color: white;">Dispatched & Assigned</span>
                                        <span *ngIf="item.statusName ==='Email Sent'" class="badge badge-pill badge-success"
                                            style="color: white;">Email Sent</span>
                                        <span *ngIf="item.statusName ==='Closed'" class="badge badge-pill badge-success"
                                            style="color: white;">Closed</span>      
                                        <span *ngIf="item.statusName ==='ApprovalPending'" class="badge badge-pill badge-success"
                                            style="color: white;">Approval Pending</span>      
                                        <span *ngIf="item.statusName ==='ToBeApproved'" class="badge badge-pill badge-success"
                                            style="color: white;">To Be Approved</span>       
                                        <span *ngIf="item.statusName ==='NoteSheetCreated'" class="badge badge-pill badge-success"
                                            style="color: white;">Note Sheet Created</span>  
                                        <span *ngIf="item.statusName ==='UpdateDispatch'" class="badge badge-pill badge-success"
                                            style="color: white;">Note Sheet Updated</span>                            
                                    </td>
                                </tr>
                            </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>